import Vue from "vue";

import api from "../api";

const baixarCartaNegativa = payload => {
  return Vue.api.get(api.cartaNegativa(payload));
};

const cartaNegativaStatus = payload => {
  return Vue.api.get(api.cartaNegativaStatus(payload));
};

const buscaGuiasGrid = payload => {
  return Vue.api.get(api.guiasGrid(payload));
};

export { baixarCartaNegativa, buscaGuiasGrid, cartaNegativaStatus };
